const ICONS = {
  success: '<path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />',
  error: '<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />',
  warning: '<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />',
  info: '<path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />'
}

const CSS_CLASS = {
  success: "toast-success",
  error: "toast-error",
  warning: "toast-warning",
  info: "toast-info"
}

export function showToast(message, type = "success") {
  const container = document.querySelector(".toast-container")
  if (!container) return

  const cssClass = CSS_CLASS[type] || CSS_CLASS.info
  const iconPath = ICONS[type] || ICONS.info

  const div = document.createElement("div")
  div.className = cssClass
  div.setAttribute("data-controller", "toast")
  div.setAttribute("data-toast-auto-dismiss-value", "true")
  div.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
      ${iconPath}
    </svg>
    <span class="text-sm flex-1">${message}</span>
    <button type="button" class="flex-shrink-0 opacity-60 hover:opacity-100" data-action="toast#dismiss">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  `

  container.appendChild(div)
}
